import { FC, memo } from "react";
import { StyledEditPackageAmountContainer, StyledEditPackageButtonContainer, StyledEditPackageContainer, StyledEditPackageServiceRow } from "./EditPackage.styled";
import { Button } from "@/components/atoms";
import { EditTemplateServiceProps } from "./EditPackage.interface";

const EditPackageService : FC<EditTemplateServiceProps> = ({
    orderTemplateService,
    onServiceChange
}) => {
    return (<><p>{orderTemplateService.name}</p>
        <StyledEditPackageContainer>
            <StyledEditPackageServiceRow title={orderTemplateService.name} backgroundImage={orderTemplateService.imageUrl}></StyledEditPackageServiceRow>
            <StyledEditPackageButtonContainer>
                <Button style={{margin: '0px 5px'}} onClick={() => onServiceChange(orderTemplateService.orderTypeId, Math.max(orderTemplateService.defaultAmount - 1, 0)) }>-</Button>
                <StyledEditPackageAmountContainer>{orderTemplateService.defaultAmount}</StyledEditPackageAmountContainer>
                <Button style={{margin: '0px 5px'}}  onClick={() => onServiceChange(orderTemplateService.orderTypeId, orderTemplateService.defaultAmount + 1) }>+</Button>
            </StyledEditPackageButtonContainer>
        </StyledEditPackageContainer>
    </>)
}

export default memo(EditPackageService);